import { memo } from "react";
import { Button } from "..";

import { useTranslation } from "react-i18next";
import { EXPORT_TYPES } from "../../../constants/common";

interface ExportToExcelPDFButtonProps {
  onExport?: (type: EXPORT_TYPES) => Promise<void>;
}

const ExportToExcelPDFButton = ({ onExport }: ExportToExcelPDFButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3">
      <Button
        onClick={() => onExport?.(EXPORT_TYPES.PDF)}
        className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:ring-white dark:text-white"
      >
        {t("exportToPDF")}
      </Button>
      <Button
        onClick={() => onExport?.(EXPORT_TYPES.EXCEL)}
        className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent dark:ring-white dark:text-white"
      >
        {t("exportToExcel")}
      </Button>
    </div>
  );
};

export default memo(ExportToExcelPDFButton);
